// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-user-content{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.CmtAuth{
width: 90%;
border: grey 2px solid;
border-radius: 10px;
}
.lblCmtAuth{
    position: absolute;
  left: 30px;
  top: -12px;
  color: gray;
}
.auth-modal
{
  width: 99% !important;
}
.denied{
    width: 99% !important;
    /* border: 2px solid rgb(235, 42, 42) !important */
}
.head-card-users.denied{
    background-color: rgb(235, 42, 42) !important;
    width: 100% !important;
}
.authorize{
    width: 99% !important;
    /* border: 2px solid rgb(30, 172, 30) !important */
}
.head-card-users.authorize{
    background-color: rgb(30, 172, 30) !important;
    width: 100% !important;
}
.cont-info-modal-delete{
    position: relative;
    display: block;
    width: 95%;
    height: 95%;
}
.cont-message-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}
.txt-message-modal-delete{
    font-size: large;
    color: rgb(235, 42, 42);
    letter-spacing: 1px;
}
.cont-user-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 40%;
    justify-content: center;
    align-items: center;
}
.txt-user-modal-delete-buzon{
    font-size: medium;
    color: rgb(51, 51, 51);
    letter-spacing: 1px;
}
.cont-btn-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/cis-components/styles/ModalReqAuth.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;AACA,UAAU;AACV,sBAAsB;AACtB,mBAAmB;AACnB;AACA;IACI,kBAAkB;EACpB,UAAU;EACV,UAAU;EACV,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;AACA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,kDAAkD;AACtD;AACA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".modal-user-content{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #fff;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.CmtAuth{\r\nwidth: 90%;\r\nborder: grey 2px solid;\r\nborder-radius: 10px;\r\n}\r\n.lblCmtAuth{\r\n    position: absolute;\r\n  left: 30px;\r\n  top: -12px;\r\n  color: gray;\r\n}\r\n.auth-modal\r\n{\r\n  width: 99% !important;\r\n}\r\n.denied{\r\n    width: 99% !important;\r\n    /* border: 2px solid rgb(235, 42, 42) !important */\r\n}\r\n.head-card-users.denied{\r\n    background-color: rgb(235, 42, 42) !important;\r\n    width: 100% !important;\r\n}\r\n.authorize{\r\n    width: 99% !important;\r\n    /* border: 2px solid rgb(30, 172, 30) !important */\r\n}\r\n.head-card-users.authorize{\r\n    background-color: rgb(30, 172, 30) !important;\r\n    width: 100% !important;\r\n}\r\n.cont-info-modal-delete{\r\n    position: relative;\r\n    display: block;\r\n    width: 95%;\r\n    height: 95%;\r\n}\r\n.cont-message-modal-delete{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 30%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.txt-message-modal-delete{\r\n    font-size: large;\r\n    color: rgb(235, 42, 42);\r\n    letter-spacing: 1px;\r\n}\r\n.cont-user-modal-delete{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 40%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.txt-user-modal-delete-buzon{\r\n    font-size: medium;\r\n    color: rgb(51, 51, 51);\r\n    letter-spacing: 1px;\r\n}\r\n.cont-btn-modal-delete{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 30%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
